import routerOptions0 from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/usr/src/app/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}